<div class="units">
  <form class="units__form" [formGroup]="form">
    @for (i of _units; track i.id) {
      <div class="unit" [class.active]="i.id===unit?.id">
        <label>
          <input class="unit__input" type="radio" formControlName="unitControl" [value]="i"/>
          <span class="unit__name">{{ i.shortName }}</span>
        </label>
      </div>
    }
  </form>
</div>
